import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import PersonFieldLabel from '../PersonFieldLabel';

function EmailAddressField() {
  return (
    <div className="my-4 w-full">
      <div className="block mr-6">
        <div className="w-full">
          <PersonFieldLabel htmlFor="email-address-input">
            Email Address
          </PersonFieldLabel>
        </div>
        <div className="w-auto">
          <FormikInput id="email-address-input" name="emailAddress" />
        </div>
      </div>
    </div>
  );
}

export default EmailAddressField;
